import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { MessageCircleIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const whatsappMessage = `Hola, soy ${formData.name} de ${formData.company}. Estoy interesado en ${formData.service}. ${formData.message}`;
    window.open(`https://wa.me/50245607548?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const contactMethods = [{
    icon: MessageCircleIcon,
    title: 'WhatsApp',
    value: '+502 4560 7548',
    href: 'https://wa.me/50245607548?text=Hola%2C%20estoy%20interesado%20en%20los%20servicios%20de%20Bodenor.',
    primary: true
  }, {
    icon: MailIcon,
    title: 'Correo Electrónico',
    value: 'Zacaparenta123@gmail.com',
    href: 'mailto:Zacaparenta123@gmail.com',
    primary: false
  }, {
    icon: PhoneIcon,
    title: 'Teléfono',
    value: '+502 4560 7548',
    href: null,
    primary: false
  }];
  return <section id="contact" className="bg-black py-20 px-4 relative overflow-hidden scroll-mt-20" data-id="element-43">
      {/* Background grid */}
      <div className="absolute inset-0 opacity-5" data-id="element-44">
        <div className="absolute inset-0" style={{
        backgroundImage: `
            linear-gradient(rgba(252, 211, 77, 0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(252, 211, 77, 0.3) 1px, transparent 1px)
          `,
        backgroundSize: '60px 60px'
      }} data-id="element-45" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-47">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-48">
            ¿Listo para llevar tu operación al{' '}
            <span className="text-yellow-400" data-id="element-49">siguiente nivel?</span>
          </h2>
          <p className="text-xl text-gray-300" data-id="element-50">Conversemos.</p>
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: 96
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent mx-auto mt-4" data-id="element-51" />
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-52">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-53">
            <div className="bg-gradient-to-br from-zinc-900 to-black border border-zinc-800 rounded-xl p-8 relative overflow-hidden" data-id="element-54">
              <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-400/5 blur-3xl" data-id="element-55" />

              <h3 className="text-2xl font-bold text-white mb-6 relative z-10" data-id="element-56">
                Contacto Directo
              </h3>

              <div className="space-y-4 relative z-10" data-id="element-57">
                {contactMethods.map((method, index) => <motion.div key={index} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} data-id="element-58">
                    {method.href ? <a href={method.href} className={`flex items-center gap-4 p-4 rounded-lg transition-all duration-300 ${method.primary ? 'bg-gradient-to-r from-yellow-400 to-yellow-500 text-black hover:shadow-[0_0_30px_rgba(252,211,77,0.4)]' : 'border border-zinc-700 text-white hover:border-yellow-400 hover:bg-yellow-400/5'}`} data-id="element-59">
                        <method.icon size={24} data-id="element-60" />
                        <div data-id="element-61">
                          <p className="font-semibold" data-id="element-62">{method.title}</p>
                          <p className={`text-sm ${method.primary ? 'text-black/80' : 'text-gray-300'}`} data-id="element-63">
                            {method.value}
                          </p>
                        </div>
                      </a> : <div className="flex items-center gap-4 p-4 border border-zinc-700 text-white rounded-lg" data-id="element-64">
                        <method.icon size={24} data-id="element-65" />
                        <div data-id="element-66">
                          <p className="font-semibold" data-id="element-67">{method.title}</p>
                          <p className="text-sm text-gray-300" data-id="element-68">
                            {method.value}
                          </p>
                        </div>
                      </div>}
                  </motion.div>)}
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-gradient-to-br from-zinc-900 to-black border border-zinc-800 rounded-xl p-8 relative overflow-hidden" data-id="element-69">
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-yellow-400/5 blur-3xl" data-id="element-70" />

            <h3 className="text-2xl font-bold text-white mb-6 relative z-10" data-id="element-71">
              Envíanos un Mensaje
            </h3>

            <form onSubmit={handleSubmit} className="space-y-4 relative z-10" data-id="element-72">
              {[{
              id: 'name',
              label: 'Nombre',
              type: 'text'
            }, {
              id: 'company',
              label: 'Empresa',
              type: 'text'
            }].map((field, index) => <motion.div key={field.id} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} data-id="element-73">
                  <label htmlFor={field.id} className="block text-sm font-semibold text-gray-300 mb-2" data-id="element-74">
                    {field.label} *
                  </label>
                  <input type={field.type} id={field.id} name={field.id} required value={formData[field.id as keyof typeof formData]} onChange={handleChange} className="w-full px-4 py-3 bg-black border border-zinc-700 rounded-lg text-white focus:outline-none focus:border-yellow-400 focus:ring-1 focus:ring-yellow-400 transition-all duration-300" data-id="element-75" />
                </motion.div>)}

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-76">
                {[{
                id: 'phone',
                label: 'Teléfono',
                type: 'tel'
              }, {
                id: 'email',
                label: 'Correo',
                type: 'email'
              }].map((field, index) => <motion.div key={field.id} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: (index + 2) * 0.1
              }} data-id="element-77">
                    <label htmlFor={field.id} className="block text-sm font-semibold text-gray-300 mb-2" data-id="element-78">
                      {field.label} *
                    </label>
                    <input type={field.type} id={field.id} name={field.id} required value={formData[field.id as keyof typeof formData]} onChange={handleChange} className="w-full px-4 py-3 bg-black border border-zinc-700 rounded-lg text-white focus:outline-none focus:border-yellow-400 focus:ring-1 focus:ring-yellow-400 transition-all duration-300" data-id="element-79" />
                  </motion.div>)}
              </div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.4
            }} data-id="element-80">
                <label htmlFor="service" className="block text-sm font-semibold text-gray-300 mb-2" data-id="element-81">
                  Servicio de interés *
                </label>
                <select id="service" name="service" required value={formData.service} onChange={handleChange} className="w-full px-4 py-3 bg-black border border-zinc-700 rounded-lg text-white focus:outline-none focus:border-yellow-400 focus:ring-1 focus:ring-yellow-400 transition-all duration-300" data-id="element-82">
                  <option value="" data-id="element-83">Selecciona un servicio</option>
                  <option value="Renta de Bodegas" data-id="element-84">Renta de Bodegas</option>
                  <option value="Báscula" data-id="element-85">Báscula</option>
                  <option value="Patio de Camiones" data-id="element-86">Patio de Camiones</option>
                </select>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.5
            }} data-id="element-87">
                <label htmlFor="message" className="block text-sm font-semibold text-gray-300 mb-2" data-id="element-88">
                  Mensaje
                </label>
                <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 bg-black border border-zinc-700 rounded-lg text-white focus:outline-none focus:border-yellow-400 focus:ring-1 focus:ring-yellow-400 transition-all duration-300 resize-none" data-id="element-89" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.6
            }} data-id="element-90">
                <Button type="submit" variant="primary" className="w-full" data-id="element-91">
                  <MessageCircleIcon size={20} data-id="element-92" />
                  Enviar por WhatsApp
                </Button>
              </motion.div>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}